<template>
    <div class="SwiperBox" ref="SwiperBox" @mouseenter="MouseFun('移入')" @mouseleave="MouseFun('移出')">
        <!-- 图片 -->
        <div class="imgBox" :style="{ left: `-${leftVal}vw`, transition: `${ition}s` }">
            <!-- <img :src="item.imgUrl" v-for="(item, index) in imgList" :key="index" /> -->
            <div style="position: relative;">
                <img src="@/images/homebanner.png" style="width: 100vw;height: 30.21vw;">
                <!-- <div class="topTitle">
                    见心即安心
                </div>
                <div class="topText">
                    您的情绪管理帮办！心理装备专家！
                </div> -->
            </div>
            <div style="position: relative;">
                <img src="@/images/homeImg.png" style="width: 100vw;height: 30.21vw;">
                <div class="topTitle">
                    见心即安心
                </div>
                <div class="topText">
                    您的情绪管理帮办！心理装备专家！
                </div>
            </div>
            <div style="position: relative;">
                <img src="@/images/agencyBanner.png" style="width: 100vw;height: 30.21vw;">
                <div class="topTitle">
                    见心即安心
                </div>
                <div class="topText">
                    您的情绪管理帮办！心理装备专家！
                </div>
            </div>
            <div style="position: relative;">
                <img src="@/images/experienceBanner.png" style="width: 100vw;height: 30.21vw;">
                <div class="topTitle">
                    见心即安心
                </div>
                <div class="topText">
                    您的情绪管理帮办！心理装备专家！
                </div>
            </div>
            <!-- 复制第一张放到最后，以实现无缝无线循环滚动效果 -->
            <div style="position: relative;">
                <img src="@/images/homebanner.png" style="width: 100vw;height: 30.21vw;">
                <!-- <div class="topTitle">
                    见心即安心
                </div>
                <div class="topText">
                    您的情绪管理帮办！心理装备专家！
                </div> -->
            </div>
        </div>
        <!-- 下方指示点容器 -->
        <div class="instBox">
            <div @click="instFun(index)" v-for="(item, index) in imgList.length" :key="index"
                :class="['inst', index === imgShow ? 'instActv' : '']">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'swiperCom',
    data() {
        return {
            imgList: [
                {
                    img: '@/images/homeImg.png',
                    title: '见心即安心',
                    text: '您的情绪管理帮办！心理装备专家！'
                },
                {
                    img: '@/images/homeImg.png',
                    title: '见心即安心',
                    text: '您的情绪管理帮办！心理装备专家！'
                },
                {
                    img: '@/images/productBanana.png',
                    title: '见心即安心',
                    text: '您的情绪管理帮办！心理装备专家！'
                },
                {
                    img: '@/images/experienceBanner.png',
                    title: '见心即安心',
                    text: '您的情绪管理帮办！心理装备专家！'
                },
            ],
            leftVal: 0, // 轮播图盒子的偏移值
            flag: true, // 用来节流防止重复点击
            start: null, // 自动执行下一张定的时器
            imgWidth: 100, // 在这里填写你需要的图片宽度
            ition: 0.6, // 设置轮播图过度时间
            imgShow: 0, // 表示当前显示的图片索引
        };
    },
    mounted() {
        // this.imgWidth = this.$refs.SwiperBox.offsetWidth // 自动获取轮播图盒子宽度
        this.startAutoPlay();
    },
    beforeUnmount() {
        clearTimeout(this.start);
    },
    methods: {
        // 这里定义一个鼠标移入移出事件，鼠标悬停时停止自动轮播，鼠标移出则重新执行自动轮播
        MouseFun(type) {
            type === '移入' ? clearTimeout(this.start) : this.startAutoPlay();
        },
        // 此为自动轮播定时器
        startAutoPlay() {
            this.start = setInterval(() => {
                this.NextFun();
            }, 3000);
        },
        // 这里通过额外封装的节流函数触发 PrevFun() 和 NextFun()，以达到防止重复点击的效果
        throttle(fun) {
            if (this.flag) {
                this.flag = false;
                fun(); // 此为模板中传递进来的PrevFun()或NextFun()函数
                setTimeout(() => {
                    this.flag = true;
                }, 650); // 设置节流间隔时间，不得小于图片过渡时间
            }
        },
        // 上一张
        PrevFun() {
            if (this.leftVal === 0) { // 判断显示的图片 是 第一张时执行
                // this.imgList.length是指循环图片数组的图片个数
                this.ition = 0; // 将过渡时间变成0，瞬间位移到最后一张图
                this.imgShow = this.imgList.length - 1; // 将高亮小点改为最后一张图
                this.leftVal = this.imgList.length * this.imgWidth; // 瞬间移动
                this.$nextTick(() => { // $nextTick是一个vue内置函数，是一个等待dom元素更新后执行的回调函数
                    setTimeout(() => { // 通过延时障眼法，归原过渡时间，执行真正的“上一张”函数
                        this.ition = 0.6;
                        this.leftVal -= this.imgWidth;
                    }, this.ition * 1000);
                });
            } else { // 判断显示的图片 不是 第一张时执行
                this.ition = 0.6;
                this.leftVal -= this.imgWidth;
                this.imgShow--;
            }
        },
        // 下一张
        NextFun() {
            if (this.leftVal === (this.imgList.length - 1) * this.imgWidth) { // 判断显示的图片 是 最后一张时执行
                this.ition = 0.6;
                this.leftVal += this.imgWidth;
                this.imgShow = 0;
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.ition = 0;
                        this.leftVal = 0;
                    }, this.ition * 1000);
                });
            } else { // 判断显示的图片 不是 最后一张时执行
                this.ition = 0.6;
                this.leftVal += this.imgWidth;
                this.imgShow++;
            }
        },
        // 点击小圆点
        instFun(index) {
            this.ition = 0.6;
            this.leftVal = index * this.imgWidth;
            this.imgShow = index;
        },
    },
};
</script>

<style scoped>
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

/* 图片容器样式 */
.SwiperBox {
    position: relative;
    width: 100vw;
    height: 30.21vw;
    box-sizing: border-box;
    cursor: pointer;
    overflow: hidden;
}

.imgBox {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 30.21vw;
    display: flex;
    justify-content: flex-start;
}

/* 图片默认样式 */
.imgBox img {
    flex-shrink: 0;
    width: 26.04vw;
    /* 500 / 1920 * 100 */
    height: 15.63vw;
    /* 300 / 1920 * 100 */
}

/* 两个按钮共有的样式，也可直接使用箭头图片替代 */
.leftBtn,
.rightBtn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 1.56vw;
    /* 30 / 1920 * 100 */
    height: 1.56vw;
    /* 30 / 1920 * 100 */
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(109, 109, 109, 0.445);
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
    font-size: 0.63vw;
    /* 12 / 1920 * 100 */
    font-weight: 500;
    user-select: none;
}

.leftBtn {
    left: 0.52vw;
    /* 10 / 1920 * 100 */
}

.rightBtn {
    right: 0.52vw;
    /* 10 / 1920 * 100 */
}

/* 下方指示器盒子 */
.instBox {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 1.34vw;
    /* 30 / 1920 * 100 */
    display: flex;
}

/* 小圆点 */
.inst {
    width: 0.52vw;
    /* 10 / 1920 * 100 */
    height: 0.52vw;
    /* 10 / 1920 * 100 */
    border: 0.05vw solid #ccc;
    /* 1 / 1920 * 100 */
    margin-right: 0.42vw;
    /* 8 / 1920 * 100 */
    background: #ccc;
    border-radius: 50%;
    cursor: pointer;
}

.inst:last-child {
    margin-right: 0;
}

.instActv {
    border: 0.05vw solid #fff;
    /* 1 / 1920 * 100 */
    background: #fff;
}

#app {
    width: 100%;
    padding: 6.25vw;
    /* 120 / 1920 * 100 */
    display: flex;
    justify-content: center;
}

.topTitle {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 3.44vw;
    color: #FEFEFC;
    line-height: 7.29vw;
    text-align: justifyLeft;
    font-style: normal;
    text-transform: none;
    background: -webkit-linear-gradient(0deg, #41B9FF 0%, #0093E8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: absolute;
    left: 21.15vw;
    top: 10.57vw;
}

.topText {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 1.46vw;
    color: #444444;
    line-height: 7.29vw;
    text-align: justifyLeft;
    font-style: normal;
    text-transform: none;
    position: absolute;
    left: 21.15vw;
    top: 15vw;
}
</style>